(() => {
  function initHomepage(host) {
    if (!host || host.dataset.starcoReady === 'true') return;

    const templateId = host.getAttribute('data-template-id');
    const template = templateId ? document.getElementById(templateId) : null;
    if (!template) return;

    const shadow = host.shadowRoot || host.attachShadow({ mode: 'open' });
    shadow.append(template.content.cloneNode(true));
    host.dataset.starcoReady = 'true';

    const pageRoot = shadow.querySelector('[data-starco-home]');
    if (!pageRoot) return;
    pageRoot.classList.add('js');

    pageRoot.querySelector('.skip-link')?.addEventListener('click', (event) => {
      event.preventDefault();
      const main = pageRoot.querySelector('#starco-home-main');
      main?.focus();
      main?.scrollIntoView({ block: 'start' });
    });

    const revealItems = pageRoot.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -7% 0px', threshold: 0.08 });
      revealItems.forEach((item) => observer.observe(item));
    } else {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    }

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setupRotator({ root, pageSelector, dotSelector, previousSelector, nextSelector, countSelector, interval }) {
      if (!root) return;
      const pages = [...root.querySelectorAll(pageSelector)];
      if (!pages.length) return;
      const dots = dotSelector ? [...root.querySelectorAll(dotSelector)] : [];
      const previous = previousSelector ? root.querySelector(previousSelector) : null;
      const next = nextSelector ? root.querySelector(nextSelector) : null;
      const count = countSelector ? root.querySelector(countSelector) : null;
      let current = 0;
      let timer;

      const show = (index) => {
        current = (index + pages.length) % pages.length;
        pages.forEach((page, pageIndex) => {
          const active = pageIndex === current;
          page.hidden = !active;
          page.classList.toggle('is-active', active);
          page.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
        });
        if (count) count.textContent = `${String(current + 1).padStart(2, '0')} / ${String(pages.length).padStart(2, '0')}`;
      };

      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (!reduceMotion) timer = window.setInterval(() => show(current + 1), interval);
      };
      const select = (index) => { show(index); start(); };

      previous?.addEventListener('click', () => select(current - 1));
      next?.addEventListener('click', () => select(current + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => select(index)));
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      root.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') select(current - 1);
        if (event.key === 'ArrowRight') select(current + 1);
      });
      show(0);
      start();
    }

    const workRotator = pageRoot.querySelector('[data-work-rotator]');

    if (workRotator && window.matchMedia('(max-width: 640px)').matches) {
      const workViewport = workRotator.querySelector('.work-viewport');
      const photos = workViewport ? [...workViewport.querySelectorAll('.work-photo')] : [];

      if (workViewport && photos.length) {
        const mobileSlides = photos.map((photo, index) => {
          const slide = document.createElement('div');
          slide.className = 'work-slide';
          slide.hidden = index !== 0;
          slide.setAttribute('aria-hidden', String(index !== 0));
          photo.querySelector('img')?.setAttribute('loading', 'eager');
          slide.append(photo);
          return slide;
        });

        workViewport.replaceChildren(...mobileSlides);
        workRotator.querySelector('.rotator-dots')?.remove();
      }
    }

    setupRotator({
      root: workRotator,
      pageSelector: '.work-slide',
      dotSelector: '[data-work-index]',
      previousSelector: '[data-work-prev]',
      nextSelector: '[data-work-next]',
      countSelector: '[data-work-count]',
      interval: 3900,
    });

    setupRotator({
      root: pageRoot.querySelector('[data-google-rotator]'),
      pageSelector: '.review-slide',
      previousSelector: '[data-google-prev]',
      nextSelector: '[data-google-next]',
      countSelector: '[data-google-count]',
      interval: 5200,
    });

    setupRotator({
      root: pageRoot.querySelector('[data-facebook-rotator]'),
      pageSelector: '.review-slide',
      previousSelector: '[data-facebook-prev]',
      nextSelector: '[data-facebook-next]',
      countSelector: '[data-facebook-count]',
      interval: 4800,
    });
  }

  function initAll() {
    document.querySelectorAll('[data-starco-home-host]').forEach(initHomepage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
